import createApp from '../createApp'
import Index from './Index.vue'

document.addEventListener('DOMContentLoaded', () => createApp(
  Index,
  ({ hooks }) => ({ hooks }),
), false)
